'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTimeDelaySeconds = exports.getEnabled = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _timeDelayTriggerKeyPaths = require('../constants/timeDelayTriggerKeyPaths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getEnabled = exports.getEnabled = (0, _getIn2.default)(_timeDelayTriggerKeyPaths.ENABLED);

var getTimeDelaySeconds = exports.getTimeDelaySeconds = (0, _getIn2.default)(_timeDelayTriggerKeyPaths.TIME_DELAY_SECONDS);